import { useEffect, useState } from 'react';
import { api, type ListResult } from '../api';

interface Activity {
  id: string;
  type: string;
  subject: string | null;
  body: string | null;
  occurredAt: string;
  outcome?: { name: string } | null;
}

interface Outcome {
  id: string;
  name: string;
}

const TYPES = ['call', 'email', 'note', 'meeting'];

export function TimelineDrawer({
  objectType,
  objectId,
  onClose,
}: {
  objectType: string;
  objectId: string;
  onClose: () => void;
}) {
  const [items, setItems] = useState<Activity[]>([]);
  const [outcomes, setOutcomes] = useState<Outcome[]>([]);
  const [type, setType] = useState('note');
  const [outcomeId, setOutcomeId] = useState('');
  const [note, setNote] = useState('');

  async function load() {
    const res = await api.get<ListResult<Activity>>(`/api/activities/timeline/${objectType}/${objectId}`);
    setItems(res.items);
  }

  useEffect(() => {
    void load();
    void api.get<Outcome[]>('/api/activity-outcomes').then(setOutcomes).catch(() => undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [objectType, objectId]);

  async function logActivity(e: React.FormEvent) {
    e.preventDefault();
    await api.post('/api/activities', {
      type,
      relatedType: objectType,
      relatedId: objectId,
      body: note || undefined,
      outcomeId: outcomeId || undefined,
    });
    setNote('');
    setOutcomeId('');
    await load();
  }

  return (
    <div className="overlay" onClick={onClose}>
      <div className="drawer" onClick={(e) => e.stopPropagation()}>
        <div className="row" style={{ justifyContent: 'space-between' }}>
          <h2>Timeline</h2>
          <button className="btn" onClick={onClose}>Close</button>
        </div>

        <form className="stack" onSubmit={logActivity}>
          <div className="row">
            <select value={type} onChange={(e) => setType(e.target.value)}>
              {TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
            </select>
            <select value={outcomeId} onChange={(e) => setOutcomeId(e.target.value)}>
              <option value="">Outcome…</option>
              {outcomes.map((o) => <option key={o.id} value={o.id}>{o.name}</option>)}
            </select>
          </div>
          <textarea placeholder="Note / summary" value={note} onChange={(e) => setNote(e.target.value)} />
          <button className="btn btn-primary" type="submit">Log activity</button>
        </form>

        <div className="stack" style={{ marginTop: '1rem' }}>
          {items.length === 0 && <p className="empty">No activity yet.</p>}
          {items.map((a) => (
            <div key={a.id} className="notif">
              <div>
                <strong>{a.type}</strong>
                {a.outcome?.name ? ` · ${a.outcome.name}` : ''}
                <span className="muted"> · {new Date(a.occurredAt).toLocaleString()}</span>
              </div>
              {a.body && <div className="muted">{a.body}</div>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
